import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginScreen from "./features/auth/LoginScreen";
import RootScreen from "./features/common/RootScreen";
import EmailLoginScreen from "./features/auth/EmailLoginScreen";
import ResetPasswordScreen from "./features/auth/ResetPasswordScreen";
import EmailSignUpScreen from "./features/auth/EmailSignUpScreen";
import EmailSignUpAuthScreen from "./features/auth/EmailSignUpAuthScreen";
import MaintenanceScreen from "./features/common/MaintenanceScreen";
import SlotPurchaseScreen from "./features/purchase/view/SlotPurchaseScreen";
import AccountSettingScreen from "./features/auth/AccountSettingScreen";
import LearningScreen from "./features/learning/view/LearningScreen";
import { ChineseCharacterModeSettingsProvider } from "./features/common/util/ChineseCharacterModeSettingsProvider";
import PolicyScreen from "./features/policy/view/PolicyScreen";

// 개발 환경 전용 미리보기 페이지. 동적 import 로 운영 빌드에는 포함되지 않는다.
const isDevelopment = process.env.NODE_ENV === "development";
const UICatalogScreen = lazy(() => import("./features/dev/UICatalogScreen"));
const ShellPreviewScreen = lazy(
  () => import("./features/dev/ShellPreviewScreen")
);
const LearningPreviewScreen = lazy(
  () => import("./features/dev/LearningPreviewScreen")
);

function App() {
  console.log(process.env.REACT_APP_ONEVOCA_APP_URL);
  console.log("Welcome!");
  return (
    <>
      <ChineseCharacterModeSettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootScreen />} />
            <Route path="/learn" element={<RootScreen />} />
            <Route path="/maintenance" element={<MaintenanceScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/login/email" element={<EmailLoginScreen />} />
            <Route
              path="/login/reset-password"
              element={<ResetPasswordScreen />}
            />
            <Route path="/login/sign-up" element={<EmailSignUpScreen />} />
            <Route
              path="/login/sign-up/auth"
              element={<EmailSignUpAuthScreen />}
            />
            <Route path="/slot-purchase" element={<SlotPurchaseScreen />} />
            <Route
              path="/account-settings"
              element={<AccountSettingScreen />}
            />
            <Route path="/learning" element={<LearningScreen />} />
            <Route path="/privacy" element={<PolicyScreen type="privacy" />} />
            <Route path="/terms" element={<PolicyScreen type="terms" />} />
            {isDevelopment && (
              <>
                <Route
                  path="/dev/ui"
                  element={
                    <Suspense fallback={null}>
                      <UICatalogScreen />
                    </Suspense>
                  }
                />
                <Route
                  path="/dev/shell"
                  element={
                    <Suspense fallback={null}>
                      <ShellPreviewScreen />
                    </Suspense>
                  }
                />
                <Route
                  path="/dev/learning"
                  element={
                    <Suspense fallback={null}>
                      <LearningPreviewScreen />
                    </Suspense>
                  }
                />
              </>
            )}
          </Routes>
        </BrowserRouter>
      </ChineseCharacterModeSettingsProvider>
    </>
  );
}

export default App;
